// Action types
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const SIGN_OUT_SUCCESS = "SIGN_OUT_SUCCESS";
export const SIGN_UP_SUCCESS = "SIGN_UP_SUCCESS";
export const SIGN_UP_ERROR = "SIGN_UP_ERROR";
export const FACEBOOK_AUTH_SUCCESS = "FACEBOOK_AUTH_SUCCESS";
export const FACEBOOK_AUTH_ERROR = "FACEBOOK_AUTH_ERROR";
export const GOOGLE_AUTH_SUCCESS = "GOOGLE_AUTH_SUCCESS";
export const GOOGLE_AUTH_ERROR = "GOOGLE_AUTH_ERROR";
export const UPDATE_SUCCESS = "UPDATE_SUCCESS";
export const UPDATE_ERROR = "UPDATE_ERROR";
export const PROFILE_AUTH_DELETE_SUCCESS = "PROFILE_AUTH_DELETE_SUCCESS";
export const PROFILE_AUTH_DELETE_ERROR = "PROFILE_AUTH_DELETE_ERROR";
export const PROFILE_DATA_DELETE_SUCCESS = "PROFILE_DATA_DELETE_SUCCESS";
export const PROFILE_DATA_DELETE_ERROR = "PROFILE_DATA_DELETE_ERROR";
export const UPDATE_EMAIL_SUCCESS = "UPDATE_EMAIL_SUCCESS";
export const UPDATE_EMAIL_ERROR = "UPDATE_EMAIL_ERROR";
export const UPDATE_PASSWORD_SUCCESS = "UPDATE_PASSWORD_SUCCESS";
export const UPDATE_PASSWORD_ERROR = "UPDATE_PASSWORD_ERROR";
export const SEND_RESET_PASSWORD_EMAIL_SUCCESS =
  "SEND_RESET_PASSWORD_EMAIL_SUCCESS";
export const SEND_RESET_PASSWORD_EMAIL_ERROR =
  "SEND_RESET_PASSWORD_EMAIL_ERROR";
export const PHOTO_UPLOAD_SUCCESS = "PHOTO_UPLOAD_SUCCESS";
export const PHOTO_UPLOAD_ERROR = "PHOTO_UPLOAD_ERROR";
export const DELETE_STORAGE_SUCCESS = "DELETE_STORAGE_SUCCESS";
export const DELETE_STORAGE_ERROR = "DELETE_STORAGE_ERROR";
export const ADD_BLOG_SUCCESS = "ADD_BLOG_SUCCESS";
export const ADD_BLOG_ERROR = "ADD_BLOG_ERROR";
export const ADD_COMMENT_SUCCESS = "ADD_COMMENT_SUCCESS";
export const ADD_COMMENT_ERROR = "ADD_COMMENT_ERROR";
export const DELETE_COMMENT_SUCCESS = "DELETE_COMMENT_SUCCESS";
export const DELETE_COMMENT_ERROR = "DELETE_COMMENT_ERROR";
export const BLOG_APPROVAL_SUCCESS = "BLOG_APPROVAL_SUCCESS";
export const BLOG_APPROVAL_ERROR = "BLOG_APPROVAL_ERROR";
export const DELETE_BLOG_SUCCESS = "DELETE_BLOG_SUCCESS";
export const DELETE_BLOG_ERROR = "DELETE_BLOG_ERROR";
export const DELETE_BLOG_FROM_STORAGE_SUCCESS =
  "DELETE_BLOG_FROM_STORAGE_SUCCESS";
export const DELETE_BLOG_FROM_STORAGE_ERROR = "DELETE_BLOG_FROM_STORAGE_ERROR";
export const DELETE_BLOG_FROM_DB_SUCCESS = "DELETE_BLOG_FROM_DB_SUCCESS";
export const DELETE_BLOG_FROM_DB_ERROR = "DELETE_BLOG_FROM_DB_ERROR";
export const ADD_NEWSLETTER_SUCCESS = "ADD_NEWSLETTER_SUCCESS";
export const ADD_NEWSLETTER_ERROR = "ADD_NEWSLETTER_ERROR";
